import type { FC } from "react";
import * as S from "./style";
import { Icon } from "@smartsuite/react-ui/lib";
import { useTranslation } from "react-i18next";
import { Colors, GrayColors } from "@smartsuite/types";

export const RecordsNoOptions: FC<{
  createNewFindAction: () => void;
}> = ({ createNewFindAction }) => {
  const { t } = useTranslation();
  return (
    <S.RecordsNoOptions>
      <S.RecordsNoOptionsIcon>
        <Icon
          size="M"
          name="info-baloon"
          color={GrayColors["G-4"]}
          width={16}
          height={16}
        />
      </S.RecordsNoOptionsIcon>
      <S.RecordsNoOptionsInner>
        {t("find-records.no-options-text")}
        <br />
        <button
          type="button"
          style={{
            cursor: "pointer",
            color: Colors.bBlue,
          }}
          onClick={createNewFindAction}
        >
          Click here
        </button>{" "}
        to create a new Find Records action.
      </S.RecordsNoOptionsInner>
    </S.RecordsNoOptions>
  );
};
